import React from "react";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toggleCart } from "../redux/action";
import CartSidebar from "./CartSidebar";

const Navbar = () => {
  const state = useSelector((state) => state.handleCart);
  const dispatch = useDispatch();
  const cartIsEmpty = state.length === 0;

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-light py-3 sticky-top">
        <div className="container">
          <NavLink className="navbar-brand fw-bold fs-4 px-2" to="/">
            A1 Pro
          </NavLink>

          <div className="d-flex align-items-center ms-auto d-lg-none">
            <button
              type="button"
              className="btn btn-outline-dark btn-sm me-2"
              onClick={() => dispatch(toggleCart())}
              disabled={cartIsEmpty}
              aria-label="Abrir carrito"
            >
              <i className="fa fa-cart-shopping"></i>
            </button>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-lg-auto my-2 text-center">
              <li className="nav-item">
                <NavLink className="nav-link" to="/">
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/product">
                  Cursos
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/about">
                  Sobre A1 Pro
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/contact">
                  Contacto
                </NavLink>
              </li>
            </ul>
            <div className="d-none d-lg-flex justify-content-center justify-content-lg-end mt-3 mt-lg-0">
              <button
                type="button"
                className="btn btn-outline-dark"
                onClick={() => dispatch(toggleCart())}
                disabled={cartIsEmpty}
              >
                <i className="fa fa-cart-shopping mr-1"></i> Carrito ({state.length})
              </button>
            </div>
          </div>
        </div>
      </nav>
      <CartSidebar />
    </>
  );
};

export default Navbar;
